import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { Separator } from "@base-ui-components/react/separator";
import { cleanProps, cn } from "../../utils/index.js";
import { dividerVariants } from "./Divider.variants.js";
function Divider({ className, direction = 'horizontal', type = 'solid', weight = 1, text = '', textAlign, emphasis = 'regular', ...props }) {
    const isTextShown = text && 'horizontal' === direction;
    const { containerSlot, lineSlotBefore, lineSlotAfter, textSlot } = dividerVariants({
        direction,
        type,
        isTextShown: !!isTextShown,
        textAlign,
        weight,
        emphasis,
        ...props
    });
    const classes = cn(containerSlot(), className);
    return /*#__PURE__*/ jsxs("div", {
        className: classes,
        "data-testid": "divider",
        ...cleanProps(props, [
            'direction',
            'type',
            'weight',
            'text',
            'textAlign',
            'emphasis'
        ]),
        children: [
            /*#__PURE__*/ jsx(Separator, {
                orientation: direction,
                className: lineSlotBefore()
            }),
            isTextShown ? /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsx("span", {
                        className: textSlot(),
                        children: text
                    }),
                    /*#__PURE__*/ jsx(Separator, {
                        orientation: direction,
                        className: lineSlotAfter()
                    })
                ]
            }) : null
        ]
    });
}
export { Divider };
